import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import client from '../api/client';
import { Project } from '../types';
import './Projects.css';

export default function Projects() {
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    client.get('/api/armundi/projects')
      .then(r => setProjects(Array.isArray(r.data) ? r.data : r.data.projects || []))
      .finally(() => setLoading(false));
  }, []);

  const filtered = projects.filter(p =>
    p.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleDelete = async (id: string, e: React.MouseEvent) => {
    e.preventDefault();
    if (!window.confirm('Projekt wirklich löschen?')) return;
    await client.delete(`/api/armundi/projects/${id}`);
    setProjects(prev => prev.filter(p => p.id !== id));
  };

  return (
    <div className="projects-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Projekte</h1>
          <p className="page-subtitle">{projects.length} Projekte gesamt</p>
        </div>
        <Link to="/projects/new" className="btn-primary">+ Neues Projekt</Link>
      </div>

      <div className="toolbar">
        <input
          className="search-input"
          placeholder="Projekte suchen..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      {loading ? (
        <div className="loading-state">Wird geladen...</div>
      ) : filtered.length === 0 ? (
        <div className="empty-state">
          <p className="empty-title">{search ? 'Keine Ergebnisse.' : 'Noch keine Projekte vorhanden.'}</p>
          {!search && <Link to="/projects/new" className="btn-primary" style={{marginTop:'16px', display:'inline-block'}}>Erstes Projekt anlegen</Link>}
        </div>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Modelle</th>
              <th>Erstellt</th>
              <th>Zuletzt geändert</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(p => (
              <tr key={p.id} onClick={() => navigate(`/projects/${p.id}`)} className="table-row-link">
                <td>
                  <span className="table-name">{p.name}</span>
                  {p.description && <span className="table-desc">{p.description}</span>}
                </td>
                <td><span className="badge-teal">{p._count?.models ?? p.models?.length ?? 0}</span></td>
                <td className="text-muted">{new Date(p.createdAt).toLocaleDateString('de-DE')}</td>
                <td className="text-muted">{new Date(p.updatedAt).toLocaleDateString('de-DE')}</td>
                <td>
                  <button
                    className="btn-danger-sm"
                    onClick={e => handleDelete(p.id, e)}
                  >Löschen</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
